import { ProdutoMadeiraOrcamentoContract } from "app/api/classes/OrcamentoApi"
import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import { IItemOrcamento } from "app/types/IItemOrcamento"
import { Madeira } from "app/types/Madeira"
import React, { useEffect, useState } from "react"
import { removerComponenteReact } from "../renderizarOuRemoverComponentReact"
import { TratamentoMadeira } from "./TratamentoMadeira"
import { excluirItens as excluirItensUseCase, tratamentoErroPadrao } from '../../use-cases';
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'
import globalMU from "globalMU"
import { obterParametros } from "app/use-cases/parametro/obterParametros"
import { Parametro } from "app/types/Parametro"
import { Dict } from "app/utils/Dict"

declare var window:any

export type TratamentoMadeiraItemContainerProps = {
  item: IItemOrcamento,
  somenteLeitura: boolean,
  onClose: () => void,
  onOk: () => void,
}

export const TratamentoMadeiraItemContainer = (props: TratamentoMadeiraItemContainerProps) => {
  const [open,setOpen] = useState(true)
  const [dadosMadeira, setDadosMadeira] = useState<Madeira>(null)
  const [parametros, setParametros] = useState<Parametro[]>([])

  const obterContratoTelaDadosMadeiraItem = async (identificadorOrcamento: string, identificadorItem: number) => {
    const ProdutoMadeiraOrcamento = await microuniversoApi.Orcamento.obterContratoTelaDadosMadeiraItem(identificadorOrcamento, identificadorItem)
    setDadosMadeira({
      altura: ProdutoMadeiraOrcamento.Altura,
      codigo: ProdutoMadeiraOrcamento.CodigoProduto,
      comprimento: ProdutoMadeiraOrcamento.Comprimento,
      descricao: props.item.Descricao,
      espessura: ProdutoMadeiraOrcamento.Espessura,
      largura: ProdutoMadeiraOrcamento.Largura,
      precoVenda: ProdutoMadeiraOrcamento.TipoPrecoVenda,
      precoVenda1: ProdutoMadeiraOrcamento.PrecoVenda1,
      precoVenda2: ProdutoMadeiraOrcamento.PrecoVenda2,
      precoVenda3: ProdutoMadeiraOrcamento.PrecoVenda3,
      percentualPrecoVenda2: ProdutoMadeiraOrcamento.PercentualPrecoVenda2,
      percentualPrecoVenda3: ProdutoMadeiraOrcamento.PercentualPrecoVenda3,
      qtdDisponivel:  props.item.QuantidadeEstoque,
      qtdReservada: props.item.QuantidadeReservada,
      qtdSolicitada: ProdutoMadeiraOrcamento.QuantidadeSolicitada,
      quantidade: props.item.Quantidade,
      totalM: ProdutoMadeiraOrcamento.TotalCalculadoMetro,
      unidadeVenda: ProdutoMadeiraOrcamento.Unidade,
      total: ProdutoMadeiraOrcamento.TotalCalculadoPreco
    })
  }

  const definirDadosMadeiraItem = async (identificadorOrcamento: string, identificadorItem: number, contratoMadeira: ProdutoMadeiraOrcamentoContract) => {
    try {
      globalMU.blockUI();
      const orcamentoAtualizado = await microuniversoApi.Orcamento.definirDadosMadeiraItem(identificadorOrcamento,identificadorItem, contratoMadeira)
      
      if (orcamentoAtualizado.HasErrors)
        throw(orcamentoAtualizado.Error.Message)
      
      const atualizarEstado = () => {
        const orcamentoLegado = window.orcamentoController.model
        orcamentoLegado.atualizar(orcamentoAtualizado, false, true)

        store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
      }  
      atualizarEstado()
    }
    finally { 
      globalMU.unblockUI();
    }
  }

  const atualizarParametros = async () => {
    setParametros(
        await obterParametros({
            nomes: [
                "NUMERO_CASAS_DECIMAIS_TRATAMENTO_ESPECIAL_MADEIRA",
            ]
        })
    )
}

  useEffect(() => {
    obterContratoTelaDadosMadeiraItem(store.getState().orcamento?.IdentificadorOrcamento,props.item.Identificador)
    atualizarParametros()
  },[])
 
  return <>
    {dadosMadeira && parametros.length > 0 && <TratamentoMadeira open={open} handleClose={
      async () => {
        try {
          const itensMadeiraNaoConfigurados = store.getState().orcamento?.ItensOrcamento.filter(i => i.Madeira && i.DadosMadeira == null)
          !props.somenteLeitura && await excluirItensUseCase({itens: itensMadeiraNaoConfigurados})
          setOpen(false);
          //removerComponenteReact("conteudo-pagina");
          props.onClose()
        }
        catch (e) {
          tratamentoErroPadrao(e)
        }
      } 
    }
    onOk={async (dados: Madeira) => {
      try {
        !props.somenteLeitura && await definirDadosMadeiraItem(store.getState().orcamento?.IdentificadorOrcamento,props.item.Identificador,{
          CodigoProduto: dados.codigo,
          Unidade: dados.unidadeVenda,
          Altura: dados.altura,
          Comprimento: dados.comprimento,
          Espessura: dados.espessura,
          Largura: dados.largura,
          QuantidadeSolicitada: dados.qtdSolicitada,
          TipoPrecoVenda: dados.precoVenda,
          TotalCalculadoMetro: Math.round(dados.totalM*1000)/1000,
          PrecoVenda1: dados.precoVenda1,
          PrecoVenda2: dados.precoVenda2,
          PrecoVenda3: dados.precoVenda3,
          PercentualPrecoVenda2: dados.percentualPrecoVenda2,
          PercentualPrecoVenda3: dados.percentualPrecoVenda3,
          TotalCalculadoPreco: dados.total
        })
        setOpen(false);
        //removerComponenteReact("conteudo-pagina");
        props.onOk()
      }
      finally {
      }
    } } 
    initialValues={dadosMadeira}
    numeroCasasDecimais={Number(parametros.find(p => p.Nome == 'NUMERO_CASAS_DECIMAIS_TRATAMENTO_ESPECIAL_MADEIRA')?.Valor ?? 0)}
    somenteLeitura={props.somenteLeitura}
    />}
  </>
}
